import {
  Component,
  OnInit,
  Inject,
  ChangeDetectionStrategy,
  ChangeDetectorRef
} from '@angular/core';
import { DialogRef } from '../../dialog-ref';
import { DIALOG_DATA } from '../../dialog.service';
import { takeUntil } from 'rxjs/operators';
import { interval } from 'rxjs';
import { Destroyer } from '@apps/tools';

export interface DialogConfirm {
  title: string;
  description: string;
  approve: string;
  decline: string;
  counter?: number;
}

@Component({
  selector: 'sc-dialog-confirm',
  templateUrl: './dialog-confirm.component.html',
  styleUrls: ['./dialog-confirm.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DialogConfirmComponent extends Destroyer implements OnInit {
  timeLeft = 0;
  private timer$;

  constructor(
    public dialogRef: DialogRef<DialogConfirmComponent>,
    @Inject(DIALOG_DATA) public data: DialogConfirm,
    private cdr: ChangeDetectorRef
  ) {
    super();
    this.timeLeft = this.data.counter;
  }

  ngOnInit() {
    if (this.timeLeft > 0) {
      this.timer$ = interval(1000)
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => {
          this.timeLeft--;
          this.cdr.detectChanges();
          if (this.timeLeft < 1) {
            clearInterval(this.timer$);
          }
        });
    }
  }

  close(approve?: boolean): void {
    this.dialogRef.close(approve);
  }
}
